import { http } from '../../../plugins/axios'

const actions = {
  get ({commit}, payload) {
    let url = "user_notification"
    let options = {
      emulateJSON: true
    }
    let params = {
      "perPage": payload.event.perPage,
      "page": payload.event.page,
      "sortKey": payload.event.sortKey ? payload.event.sortKey : 'id',
      "ord": payload.event.ord,
      "find": payload.event.find
    }
    http.get(url, { params }, options)
      .then(
        response => {
          commit('onNotifications', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  markAsView ({commit}, payload) {
    let url = 'user_notification'
    let params = {
      "notification_id": payload.event.id
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('redirectInspection', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  delete ({commit}, payload) {
    let url = 'user_notification'
    let params = {
      "notification_id": payload.event.id
    }
    http.delete(url, { data: params }, {})
      .then(
        response => {
          commit('onMarkAsView', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  markMultiple ({commit}, payload) {
    let url = 'general_user_notification'
    let params = {
      "notification_id": payload.event.items
    }
    http.put(url, params, {})
      .then(
        response => {
          commit('onMarkAsView', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  },
  deleteMultiple ({commit}, payload) {
    let url = 'general_user_notification'
    let params = {
      "notification_id": payload.event.items
    }
    http.delete(url, {data: params}, {})
      .then(
        response => {
          commit('onMarkAsView', {event: payload.event, response})
        },
        error => {
          commit('onError', {event: payload.event, error})
        }
      )
  }
}

export default actions